import React, { Component } from "react";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as actions from '../../../actions/'; 

import style from './BadgeClassesList.scss';
import classes from '../../../utils/cssClasses';
import Loading from '../../Loading';

class BadgeClassesList extends Component{

	componentDidMount(){
		this.props.fetchBadgeClasses();
	}

	render(){
		if (!this.props.badgeClasses){
			return (
				<Loading />
				);
		}
		return(
			<div className={classes('list-badges-container',style)}>
				<table className={classes('table',style)}>
					<thead className={classes('thead-dark',style)}>
						<tr>
							<th className={classes('text-center',style)}>#</th>
							<th className={classes('name-col',style)}>Name</th>
							<th>Description</th>
						</tr>
					</thead>
					<tbody>
						{ this.props.badgeClasses.map(badgeClass => {
							if (badgeClass.test === undefined || !badgeClass.test ){
								return (
								<tr key={badgeClass._id} className={classes('',style)}>
									<td width="80" className={classes('text-center link_col',style)}>
										<Link to={`/badgeclasses/${badgeClass._id}`}>
					    				<FontAwesomeIcon icon="eye" />
										</Link>
									</td>
									<td width="200"  className={classes('name-col',style)}>
										<Link to={`/badgeclasses/${badgeClass._id}`}>
											{badgeClass.name}
										</Link>
									</td>
									<td className={classes('')}>
										{ badgeClass.description }
									</td>
								</tr>
								 );
							}
							return false;
						})}
					</tbody>
				</table>		
			</div>
		);
	}
}

function mapStateToProps({badgeClasses}){
	return {badgeClasses};
}

export default connect(mapStateToProps,actions)(BadgeClassesList)


// WEBPACK FOOTER //
// ./src/components/Frontend/BadgeClassesList/BadgeClassesList.js